import { closeNav } from 'modules/nav/ducks/actions';
import {
  fetchNotificationCountRequest,
  fetchNotificationsRequest,
} from 'modules/notificationCenter/actions';
import { NotificationActions } from 'modules/notificationCenter/components/NotificationActions';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { H4 } from 'ui/theme';
import { NavSlider } from '../../NavSlider';
import { Notifications } from './Notifications';

/**
 * Notifications Center
 */
export const NotificationsMenu = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchNotificationsRequest());
    dispatch(fetchNotificationCountRequest());
  }, []);

  const onClose = () => {
    dispatch(closeNav());
  };

  return (
    <NavSlider
      onClose={onClose}
      headerActions={<NotificationActions />}
      headerContent={<H4>Notifications</H4>}
    >
      <Notifications />
    </NavSlider>
  );
};
